import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IProductFirstCatNavRequest) {
    (function(SortBy) {
        SortBy["FEATURED"] = "FEATURED";
        SortBy["NEWEST"] = "NEWEST";
    })(IProductFirstCatNavRequest.SortBy || (IProductFirstCatNavRequest.SortBy = {}));
    (function(Placement) {
        /**
     * Obeys filter keys, and returns filter sections (default if not specified).
     */ Placement["MAIN_GRID"] = "MAIN_GRID";
        /**
     * Skips building filter sections and limit brands that were first activated within last 30 days
     * @deprecated
     */ Placement["NEW_BRAND_CAROUSEL"] = "NEW_BRAND_CAROUSEL";
    })(IProductFirstCatNavRequest.Placement || (IProductFirstCatNavRequest.Placement = {}));
    IProductFirstCatNavRequest.build = function(partial) {
        return _object_spread({
            filter_keys: [],
            previous_filter_keys: [],
            initial_request_exposed_visual_filter_option_keys: [],
            filters_to_include: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IProductFirstCatNavRequest || (IProductFirstCatNavRequest = {}));
export var IProductFirstCatNavRequest;
